{
	"title": "Общи условия",
	"backTitle": "Назад"
}
